export const SAVE_SCROLL_POSITION = '@komigen/mobile-frontend/scroll/SAVE_SCROLL_POSITION';

export const SAVE_SCROLL_DIRECTION = '@komigen/mobile-frontend/scroll/SAVE_SCROLL_DIRECTION';

export const SAVE_SAFARI_TOOLBAR_HIDDEN = '@komigen/mobile-frontend/scroll/SAVE_SAFARI_TOOLBAR_HIDDEN';

export const SAVE_BOTTOM_REACHED = '@komigen/mobile-frontend/scroll/SAVE_BOTTOM_REACHED';

export const SCROLLING = '@komigen/mobile-frontend/scroll/SCROLLING';

export const SET_HEADROOM_IS_VISIBLE = '@komigen/mobile-frontend/scroll/SET_HEADROOM_IS_VISIBLE';
export const SET_HEADROOM_NOT_VISIBLE = '@komigen/mobile-frontend/scroll/SET_HEADROOM_NOT_VISIBLE';

const REDUCER_NAME = 'scroll';

const selectHeadroomIsForced = state => state[REDUCER_NAME].navbarIsForced;

function saveScrollPosition(path, position) {
	return {
		type: SAVE_SCROLL_POSITION,
		payload: {
			[path]: position
		}
	};
}

function saveScrollDirection(payload) {
	return {
		type: SAVE_SCROLL_DIRECTION,
		payload
	};
}

function saveBottomReached(newBottomReached) {
	return (dispatch, getState) => {
		const state = getState();
		const { bottomReached } = state.scroll;

		if (bottomReached !== newBottomReached) {
			dispatch({
				type: SAVE_BOTTOM_REACHED,
				payload: {
					bottomReached: newBottomReached
				}
			});
		}
	};
}

function saveSafariToolbarHidden(innerHeight) {
	return (dispatch, getState) => {
		const state = getState();
		const { lastInnerHeight } = state.scroll;

		if (innerHeight === lastInnerHeight) {
			return;
		}

		dispatch({
			type: SAVE_SAFARI_TOOLBAR_HIDDEN,
			payload: {
				lastInnerHeight: innerHeight,
				safariToolbarIsHidden: innerHeight > lastInnerHeight
			}
		});
	};
}

const showHeadroom = () => ({
	type: SET_HEADROOM_IS_VISIBLE
});

const hideHeadroom = () => ({
	type: SET_HEADROOM_NOT_VISIBLE
});

function reducer(
	state = {
		direction: '',
		'/': 0,
		bottomReached: false,
		lastInnerHeight: window.innerHeight,
		safariToolbarIsHidden: false,
		navbarIsForced: false
	},
	{ type, payload }
) {
	switch (type) {
		case SAVE_SCROLL_POSITION:
			return { ...state, ...payload };
		case SAVE_SCROLL_DIRECTION:
			return { ...state, direction: payload };
		case SAVE_BOTTOM_REACHED:
			return { ...state, ...payload };
		case SAVE_SAFARI_TOOLBAR_HIDDEN:
			return { ...state, ...payload };
		case SET_HEADROOM_IS_VISIBLE:
			return { ...state, navbarIsForced: true };
		case SET_HEADROOM_NOT_VISIBLE:
			return { ...state, navbarIsForced: false };
		default:
			return state;
	}
}

export {
	saveScrollPosition,
	saveScrollDirection,
	saveBottomReached,
	saveSafariToolbarHidden,
	showHeadroom,
	hideHeadroom,
	selectHeadroomIsForced
};
export default reducer;
